import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/primeng';

import { CookieInfoComponent } from './cookie-info.component';
import { LocalStorageProvider } from 'app/shared';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    TranslateModule
  ],
  exports: [
    CookieInfoComponent
  ],
  declarations: [CookieInfoComponent],
  providers: [LocalStorageProvider]
})
export class CookieInfoModule { }



// WEBPACK FOOTER //
// /dist/src/app/ui/cookie-info/cookie-info.module.ts